import { Controller, useFieldArray } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import ProductSection from "./ProductSection";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";

const DeliverySection = ({ weekIndex, control, register, getValues, errors, setValue,data }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `weeks.${weekIndex}.deliveries`,
  });

  const [categories, setCategories] = useState([]);

  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-vendor-p-categories");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
const [days, setDays] = useState([]);
  const getAllDays = async () => {
    const response = await getData("/common/masters/all-days");
    if (response?.success) {
      setDays(await Select2Data(response?.data, "day_id"));
    }
  };
  useEffect(() => {
    getAllCategories();
    getAllDays();
  }, []);

  return (
    <>
      {fields.map((delivery, deliveryIndex) => (
        <div key={delivery.id} className="border p-3 my-3">
          <Row>
            <h5>Delivery {deliveryIndex + 1}</h5>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Days</Form.Label>
                <Controller
                  control={control}
                  name={`weeks.${weekIndex}.deliveries.${deliveryIndex}.days_id`}
                  render={({ field }) => (
                    <Select
                    isMulti
                      {...field}
                      options={days}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption.value);
                        setValue(
                          `weeks.${weekIndex}.deliveries.${deliveryIndex}.days_id`,
                          selectedOption
                        );
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>

          <ProductSection
          data={data}
            weekIndex={weekIndex}
            deliveryIndex={deliveryIndex}
            control={control}
            register={register}
            getValues={getValues}
            errors={errors}
            setValue={setValue}
          />

          <button
            type="button"
            className="btn btn-danger "
            onClick={() => remove(deliveryIndex)}
          >
            Remove Delivery
          </button>
        </div>
      ))}

      <button
        type="button"
        className="btn btn-secondary"
        onClick={() => append({ products: [] })}
      >
        + Add Delivery
      </button>
    </>
  );
};

export default DeliverySection;
